import axios from 'axios'

const state = {
}

const getters = {
}

const mutations = {
}

const actions = {
  fetchWorkSchedules ({ rootGetters }, meta) {
    // `${rootGetters['api/clientsList']}?limit=${meta.limit}&offset=${meta.offset}&page=${meta.page}`,
    let params = `?limit=${meta.limit}`
    if (meta.date) {
      params += `&date=${meta.date}`
    }
    return axios.get(`${rootGetters['api/workSchedulesList']}${params}`)
      .then((res) => {
        return res
      }).catch((err) => err)
  },
  fetchWorkSpacesList ({ rootGetters }) {
    return axios.get(rootGetters['api/workSpacesList'])
      .then((res) => {
        return res
      }).catch((err) => err)
  },
  fetchWorkSchedulesScheme ({ rootGetters }, id) {
    return axios.get(rootGetters['api/workSchedulesScheme'](id))
      .then((res) => {
        return res
      }).catch((err) => err)
  },
  setWorkScheduleDay ({ rootGetters }, data) {
    return axios.post(rootGetters['api/setWorkScheduleDay'], data)
      .then((res) => {
        return res
      }).catch((err) => err)
  },
  updateWorkScheduleDay ({ rootGetters }, data) {
    return axios.put(rootGetters['api/updateWorkScheduleDay'], data)
      .then((res) => {
        return res
      }).catch((err) => err)
  },
  fetchCountStaffByDate ({ rootGetters }, data) {
    return axios.get(rootGetters['api/fetchCountStaffByDate'], data)
      .then((res) => {
        return res
      }).catch((err) => err)
  },

  fetchWorkSchedulesTables ({ rootGetters, dispatch }, meta) {
    meta = meta || {}
    meta.filialId = rootGetters['branches/getGlobalFilialId']

    /* Make unique request, other pending will be canceled */
    const url = rootGetters['api/fetchWorkSchedulesTables']
    const source = axios.CancelToken.source()
    dispatch('requests/addUniqueRequest', { url, source }, { root: true })

    return axios
      .get(url, {
        params: meta,
        cancelToken: source.token,
      })
      .then(res => {
        return res.data.data
      })
  },
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}
